<template>
  <div>
    <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
    <b-card title="KPI Process Flow" class="mb-3">
      <div class="kpi-process-flow-preview">
        <img
          :src="kpiProcessFlowImage"
          alt="KPI Process Flow"
          class="kpi-process-flow-image"
          @click="showFlowImage = true"
        />
      </div>
    </b-card>
    <b-modal
      v-model="showFlowImage"
      title="KPI Process Flow"
      hide-footer
      centered
      size="xl"
      modal-class="kpi-flow-image-modal"
      content-class="kpi-flow-image-modal-content"
      body-class="kpi-flow-image-modal-body"
    >
      <img
        :src="kpiProcessFlowImage"
        alt="KPI Process Flow"
        class="kpi-process-flow-modal-image"
      />
    </b-modal>
    <b-card title="KPI Settings">
      <b-table
        show-empty
        :items="items"
        :fields="fields"
        :busy="loading"
        responsive
      >
        <template #cell(isActive)="row">
          <b-form-checkbox
            :checked="row.item.isActive"
            @input="onActiveInput(row.item, $event)"
            :disabled="!permission.edit"
          />
        </template>
        <template #cell(displayName)="row">
          <b-form-input v-model="row.item.displayName" size="sm" :disabled="!permission.edit" />
        </template>
        <template #cell(thresholdMinutes)="row">
          <div class="threshold-cell d-flex align-items-center">
            <b-form-input
              v-model.number="row.item.thresholdMinutes"
              type="number"
              min="1"
              size="sm"
              class="threshold-input"
              :disabled="!permission.edit"
            />
            <b-button
              size="sm"
              class="threshold-save-btn flex-shrink-0"
              :disabled="!permission.edit"
              @click="saveRow(row.item)"
            >
              Save
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { userAccess } from '@/utils/utils'

export default {
  data() {
    return {
      kpiProcessFlowImage: require('@/assets/images/KPI_Process_Flow.jpeg'),
      showFlowImage: false,
      items: [],
      loading: false,
      error: '',
      fields: [
        { key: 'kpiName', label: 'KPI' },
        { key: 'displayName', label: 'Display' },
        { key: 'thresholdMinutes', label: 'Target KPI (min)' },
        { key: 'isActive', label: 'Active' },
      ],
    };
  },
  mounted() {
    document.title = 'KPI Settings | RSP';
    this.load();
  },
  computed: {
    permission() {
      return (
        userAccess('KPI Master', 'kioskKpi_menu') || {
          view: false,
          add: false,
          edit: false,
          delete: false,
          skip: false,
          all: false,
        }
      );
    },
  },
  methods: {
    async load() {
      this.error = '';
      this.loading = true;
      try {
        const result = await this.$store.dispatch('kioskKpi/fetchKpiMaster');
        this.items = (result.data || []).map((item) => ({ ...item }));
      } catch (err) {
        this.error =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          'Failed to load (requires KPI Admin / Report Viewer / Supervisor role)';
      } finally {
        this.loading = false;
      }
    },
    async saveRow(row) {
      this.error = '';
      try {
        await this.$store.dispatch('kioskKpi/updateKpiMaster', {
          id: row._id,
          payload: {
          displayName: row.displayName,
          thresholdMinutes: row.thresholdMinutes,
          isActive: row.isActive,
          },
        });
        this.$bvToast.toast('Saved', { title: 'KPI', variant: 'success', autoHideDelay: 2000 });
      } catch (err) {
        this.error =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          'Save failed';
      }
    },
    onActiveInput(row, value) {
      row.isActive = value;
      this.saveRow(row);
    },
  },
};
</script>

<style scoped>
.kpi-process-flow-preview {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
}

.kpi-process-flow-image {
  width: 90%;
  max-width: 90%;
  object-fit: contain;
  display: block;
  cursor: zoom-in;
}

.kpi-process-flow-modal-image {
  width: 100%;
  height: auto;
  max-height: calc(85vh - 5rem);
  object-fit: contain;
  display: block;
}

.threshold-cell {
  min-width: 12rem;
  gap: 0.5rem;
}

.threshold-input {
  flex: 1 1 auto;
  min-width: 0;
  margin-bottom: 0;
}
</style>

<style>
.kpi-flow-image-modal .modal-dialog {
  max-width: 92vw;
  width: 92vw;
  margin: 1.75rem auto;
}

.kpi-flow-image-modal-content {
  max-height: 88vh;
}

.kpi-flow-image-modal-body {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem 1rem;
  overflow: auto;
}
</style>
